import { render, staticRenderFns } from "./SelectLoginMethod.vue?vue&type=template&id=5ccca0f1&scoped=true&"
import script from "./SelectLoginMethod.vue?vue&type=script&lang=js&"
export * from "./SelectLoginMethod.vue?vue&type=script&lang=js&"
import style0 from "./SelectLoginMethod.vue?vue&type=style&index=0&id=5ccca0f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccca0f1",
  null
  
)

export default component.exports